<template>
  <div
    class="contact-persons-wrapper"
  >
    <div class="contact-persons-header">
      <h2
        v-if="title"
        class="contact-persons-title"
      >
        {{ title }}
      </h2>
      <p
        v-if="intro"
        class="contact-persons-intro max-w-3xl text-center mx-auto mb-14"
      >
        {{ intro }}
      </p>
    </div>
    <vue-glide
      v-if="contactPersonItems.length"
      ref="slider"
      class="carousel"
      :gap="24"
      :per-view="4"
      :breakpoints="{
        1024: {
          perView: 3
        },
        800: {
          perView: 2
        },
        600: {
          perView: 1
        }
      }"
    >
      <vue-glide-slide
        v-for="(contactperson, i) in contactPersonItems"
        :key="i"
        class="carousel-slide"
      >
        <CardContactPerson
          :image="contactperson.image"
          :full-name="contactperson.fullName"
          :function-title="contactperson.functionTitle"
          :phone-number="contactperson.phoneNumber"
          :email-address="contactperson.emailAddress"
          :class="{'bg-white': bgColor, 'bg-primary-delta': !bgColor }"
        />
      </vue-glide-slide>
      <template
        v-if="contactPersonItems.length >= 4 "
        slot="control"
      >
        <button
          data-glide-dir="<"
          class="glide__arrow glide__arrow--left"
          :class="{ 'glide__arrow--disabled': noPrevSlide }"
        >
          <chevron-left class="icon" />
        </button>
        <button
          data-glide-dir=">"
          class="glide__arrow glide__arrow--right"
          :class="{ 'glide__arrow--disabled': noNextSlide }"
        >
          <chevron-right class="icon" />
        </button>
      </template>
    </vue-glide>
  </div>
</template>

<script>
import CardContactPerson from '@/components/card/CardContactPerson.vue';
import { Glide, GlideSlide } from 'vue-glide-js';
import 'vue-glide-js/dist/vue-glide.css';

export default {
  name: 'KfContactPersons',
  components: {
    CardContactPerson,
    ChevronLeft: () => import(/* webpackChunkName: "main"*/ '@/components/svg/ChevronLeft.vue'),
    ChevronRight: () => import(/* webpackChunkName: "main"*/ '@/components/svg/ChevronRight.vue'),
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    intro: {
      type: String,
      default: '',
    },
    contactPersonItems: {
      type: Array,
      required: true
    },
    bgColor: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      noPrevSlide: false,
      noNextSlide: false,
    };
  },
};
</script>

<style lang="postcss">
.contact-persons {
  &-title,
  &-intro {
    display: flex;
    justify-content: center;
  }

  &-carousel{
    margin-right: 20px;
  }

  &-wrapper {
    .carousel {
        .glide__track {
          @apply pl-0;
        }
      }
  }
}
</style>

